import { jsx as _jsx } from "react/jsx-runtime";
import { useAemConfig } from '@as-react/common-components';
import { isOneSizeProduct } from '@as-react/common-utils';
import { Box } from '@yonderland/andes-react';
import { SizeSelectV2 } from '../product-detail/size-select-v2/SizeSelectV2';
export const PromoBasketPopupSizeSelect = ({ basketValidationState, sizes, selectedSku, sizeRecommendation, selectSize, }) => {
    const { oneSizeProductCode } = useAemConfig();
    const oneSizeProduct = isOneSizeProduct(sizes, oneSizeProductCode);
    if (oneSizeProduct) {
        return null;
    }
    return (_jsx(Box, { paddingBlockEnd: { base: '3', md: '4' }, children: _jsx(SizeSelectV2, { id: "promo_basket_popup_size_select", isModal: true, sizes: sizes, selectedSku: selectedSku, selectSize: selectSize, sizeRecommendation: sizeRecommendation, basketValidationState: basketValidationState, isOneSizeProduct: oneSizeProduct, appendToBody: false }) }));
};
